import React, { useState, useEffect } from 'react';
import FormResa from './FormResa';

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, TableBody, IconButton, Typography } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import FormClient from '../sales/FormClient';
import { initClient, initErrorsResa, initResa } from '../StockFormsStruct';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';
import ConfirmFormTemplate from '../transfers/Forms/ConfirmFormTemplate';

const Form = (props) => {
    const [sending, setSending] = useState(false);

    const [state, setState] = useState({ 
        resa: Object.assign({},initResa),
        errors: Object.assign({},initErrorsResa),
        view: "resa",
        numberProd:1,
        sending: false,
        uniqueID: generateUniqueId(),
        form: <div></div>,  // Liste des produits
    })
    const [fieldList, setFieldList] = useState([
        {name: "shop_id", label:"Magasin", display: state.resa.shop_idDisplay.label},
        {name: "usage_date", label:"Date d'utilisation prévue", display: state.resa.usage_date.toLocaleDateString("fr-FR")},
        {name: "comments", label:"Commentaires", display: state.resa.comments},
        {name: "products"},   
        {name: "totalArt"},   
    ])
    useEffect(() => {
        console.log('state.resa a changé :', state.resa);
        createAddForm()
    }, [state.resa.products]);
    useEffect(() => {
        setFieldList([
            {name: "shop_id", label:"Magasin", display: state.resa.shop_idDisplay.label},
            {name: "usage_date", label:"Date d'utilisation prévue", display: state.resa.usage_date.toLocaleDateString("fr-FR")},
            {name: "comments", label:"Commentaires", display: state.resa.comments},
            {name: "products"},   
            {name: "totalArt"},   
        ])
    }, [state.resa.shop_idDisplay,state.resa.comments,state.resa.usage_date]);
    
    const handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");
            
            setState(prevState => ({...prevState,
                resa:{
                    ...prevState.resa,
                    [name]:value,
                    [displayName]:option
                }
            }))
        } else if(name === "shop_id"){
            console.log("change shop_id");
            
            setState(prevState => ({...prevState,
                resa:{
                    ...prevState.resa,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                        }
                    ],
                },
                numberProd:1
            }))
        } else {
            setState(prevState => ({...prevState,
                resa:{
                    ...prevState.resa,
                    [name]:value,
                    [displayName]:option
                }
            }))
        }        
    }
    const handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value
        const shop_id = state.resa.shop_id
        const max = findMax(value, shop_id)    

        let cpProducts = state.resa.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max
        cpProducts[index].display = option
        
        setState(prevState => ({...prevState,
            resa:{
                ...prevState.resa,
                products:cpProducts,
            }
        }))        
    }

    const findMax = (product_id, shop_id, list = props.AVAILABLE) => { // return available stock and it's id
        let max = 0

        Object.values(list).map( stock => {            
            if(stock.product_id === product_id  && stock.shop_id === shop_id ){    
                max = stock.quantity
                return                    
            }
        })   
        return max
    }
  
    const createProductList = () => {
        const  { AVAILABLE, PRODUCTS } = props
        const { resa } = state;
        const list = []

        // if(AVAILABLE){
        //     let selectedProds = resa.products.map( prod => prod.product_id)

        //     Object.values(AVAILABLE).map( stock => {   
        //         let selected = selectedProds.includes(stock.product_id)
        //         if(stock.shop_id === resa.shop_id && stock.quantity > 0){
        //             list.push ({
        //                 value: stock.product_id, 
        //                 label: `${PRODUCTS[ stock.product_id ].marque} - ${PRODUCTS[ stock.product_id ].name} — ${PRODUCTS[ stock.product_id ].ref}`, 
        //                 disabled: selected
        //             })
        //         }
        //     })
        // }
        if(PRODUCTS){
            let selectedProds = resa.products.map( prod => prod.product_id)
            Object.values(PRODUCTS).map( prod => {   
                let dispo = false
                if (!prod.is_disabled){
                    if (state.resa.shop_id){
                        let max = findMax(prod.id, state.resa.shop_id)
                        if (max > 0) {
                            dispo = true
                        }
                    }
                    let selected = (selectedProds.includes(prod.id))
                    let option = {
                        value: prod.id, 
                        label: `${prod.marque} - ${prod.name} — ${prod.ref}`, 
                        disabled: selected,
                        dispo,
                    }
                    if (dispo){
                        list.unshift(option)
                    } else {
                        list.push (option)
                    }
                }
                
            })
        }
        list.unshift({value: "", label: "Chosissez un Produit"})
        return list
    }

    const createAddForm = () => {
        const tab = []
        const products = createProductList()

        // console.log("[INFO] CREATE ADD FORM INDEX ");
        for (let i = 0; i < state.numberProd;i++) {
            
            tab.push(
                <TableRow key={i} >             
                    <ProductLineCell
                        numberProd={state.numberProd}
                        handleDeleteProd={() => handleDeleteProd(i)}
                        options={products}
                        value={state.resa.products[i].display}
                        onChange={option => handleSelectProducts(option,i)}
                        error={state.errors.products[i].product_id}
                        PRODUCTS={props.PRODUCTS}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            // max={state.resa.products[i].max} 
                            step={10} 
                            className="form-control input-sm" 
                            onChange={handleChange} 
                            value={state.resa.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            title="Quantité"
                            error={state.errors.products[i].quantity}
                            helperText={state.resa.products[i].max ? "Disponible : "+ state.resa.products[i].max :"" }
                        />
                    </TableCell>
                </TableRow>                                        
            )
        }

        setState(prevState => ({...prevState,
            form:tab,
        }))
        return tab;
    }
    const handleAddProd = () => {// must add new line in the form to add a product to the resa
        
        const shop_id = state.resa.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        setState(prevState => ({...prevState,
            resa:{
                ...prevState.resa,
                products:[
                    ...state.resa.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                }]
            },
            errors:{
                ...prevState.errors,
                products:[
                    ...prevState.errors.products,{                      
                    product_id:"",
                    quantity:"",                    
                }]
            },
            numberProd:prevState.numberProd+1,
        }))    
    }
    const handleAddProdByCSV = (productList) =>{
        console.log("Form RESA F  ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = state.resa.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form RESA F ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            const max = findMax(value[5].id, shop_id)    
            if (max.stock_id ===""){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            nbOfProduct++

             const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: max.max
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
        })
        console.log("Form RESA F ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form RESA F ,handleAddProdByCSV,Add product",productListLocal.length)
            setState(prevState => ({...prevState,
                resa:{
                    ...prevState.resa,
                    products:[...productListLocal]
                },
                errors:{
                    ...prevState.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }))  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    const handleDeleteProd = (index) => {
        let cpProducts = [].concat(state.resa.products)
        let cpErrors = [].concat(state.errors.products)
        // let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        // cpProducts.map( prod => {
        //     if ( prod.priceR && prod.quantity && prod.priceTotal){
        //         total += parseFloat(prod.priceTotal)
        //     }
        // }) 
        setState(prevState => ({...prevState,
            resa:{
                ...prevState.resa,
                products: cpProducts,
                // total,
            },
            errors:{
                ...prevState.errors,
                products: cpErrors
            },
            numberProd: prevState.numberProd - 1,
        }))   
    }
    const handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(state.resa.products)
            cpProducts[index][name] = value
            if(name === "quantity") {   
                if(value === "" || regex.test(value)){// update value only if its a int
                    setState(prevState => ({...prevState,
                        resa:{
                            ...prevState.resa,
                            products:cpProducts,
                        }
                    })) 
                }
                
            } else {
                setState(prevState => ({...prevState,
                    resa:{
                        ...prevState.resa,
                        products:cpProducts,
                    }
                })) 
            }
                    
        } else {
            if (field === "comments"){
                setState(prevState => ({...prevState,
                    resa:{
                        ...prevState.resa,
                        [field]:value
                    }
                }))
            }else{
                setState(prevState => ({...prevState,
                    resa:{
                        ...prevState.resa,
                        [field]:value
                    }
                })) 
            }

        }
    }
    const handleChangeDate = (selectedDate) => {
        console.log("IN HANDLE CHANGE date", selectedDate);
        
        setState(prevState => ({...prevState,
            resa:{
                ...prevState.resa,
                usage_date: selectedDate,

            }
        }))
    }
    const validate = () => {
        let noErrors = true
        let errors = state.errors
        const notRequired = ["cli_type", "cli_typeDisplay", "usage_date"]
        const notRequiredProdItem = ["max"]

        const resa = Object.assign({}, state.resa)
        Object.keys(resa).map( field => {
            console.log(field);
            
            if( isEmpty(resa[field]) && !notRequired.includes(field) ) {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                resa.products.map((item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(notRequiredProdItem.includes(field2)){
                            errors.products[j][field2] = ""
                        } else if(item[field2] === "" || item[field2] === 0 || item[field2] === "0"){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } 
                        // else if(parseInt(item.max) < parseInt(item.quantity)){
                        //     noErrors = false
                        //     errors.products[j].quantity = "Stock insuffisant"
                        // } 
                        else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })
                
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        setState(prevState => ({...prevState,
            errors : errors
        })) 
        if(noErrors){
            setState(prevState => ({...prevState,
                view : "confirm"
            }))
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        
        // return noErrors
    }

    const handleSubmit = async () => {

        setSending(true)

        let resa = Object.assign({}, state.resa)
        resa.id = ""
        resa.nature = "reservation_demande"
        resa.unique_id = state.uniqueID

        for (let i = 0; i < resa.products.length; i++){
            resa.products[i].quantity = parseInt(resa.products[i].quantity)                      
        }
            
        await props.createResaDemand(resa)
            
        if(props.STATE.resas.error){
            console.log("ERROR", props.STATE.resas.error);
            setSending(false)
            toast.error( props.STATE.resas.error)
        } else {
            //success 
            setSending(false)
            toast.info("Demande enregistrée avec succès")
            clearForms()                        
            props.handleClose()
        }                
    }
    const clearForms = () => {
        setState({
            numberProd:1,
            
            resa: Object.assign({}, initResa),
            client: Object.assign({}, initClient),
            // errors?
            errors: Object.assign({}, initErrorsResa),
            errorsClient: Object.assign({}, initClient),                
            
        })
    }


    
        return (
            <React.Fragment>
                {state.view === "resa" &&
                    <PopUp 
                        title="Nouvelle demande de reservation" 
                        close={props.handleClose}
                        submitAction={validate}
                        appbar
                    >
                        <FormResa 
                            {...state} 
                            {...props} 
                            handleSelect={handleSelect}
                            createAddForm={state.form}
                            handleAddProd={handleAddProd}
                            handleAddProdByCSV={handleAddProdByCSV}
                            handleChange={handleChange}
                            handleChangeDate={handleChangeDate}
                            // validate={validate}
                            // handleClose={props.handleClose}
                        />
                    </PopUp>
                }
               
                {state.view === "confirm" &&
                <PopUp 
                    title="Récapitulatif" 
                    close={() => setState({view: "resa"})}
                    submitAction={ handleSubmit }
                    submitTitle="Valider"
                    disabledSubmit={sending}
                    maxWidth="md"
                >
                    <TableLayout>
                        <TableBody>        
                            <ConfirmFormTemplate
                                fieldList={fieldList}
                                transfer={state.resa}
                            />                 
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
}

export default Form;